export class TipoPercepcionConstants {
  static PRENATAL = 'Prenatal'
  static MATERNIDAD = 'Maternidad'
  static MATERNIDAD_DOWN = 'Maternidad down'
}
